function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Credit Card name
 * 
 */
import React, { Component } from 'react';
import TextInput from '../../../../components/text-input/TextInput';
import { cardHolder } from '../../../../actions/index';
import { connect } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
class CardHolder extends Component {
  render() {
    const {
      cardHolder,
      creditCard,
      gateway
    } = this.props;
    const name = gateway.name === 'windcave' ? 'CardHolderName' : gateway.name === 'securepay' ? 'EPS_CARDHOLDER' : 'card_holder';
    const values = {
      [name]: {
        ...creditCard.card_holder
      }
    };
    return /*#__PURE__*/_jsx(TextInput, {
      label: "Name on credit card",
      name: name,
      handleChange: cardHolder,
      onBlur: cardHolder
      // $$FlowFixMe
      ,
      values: values,
      placeholder: "Name on credit card",
      section: ""
    });
  }
}
_defineProperty(CardHolder, "defaultProps", {
  cardHolder: () => null,
  creditCard: {
    cardHolder: {
      error: false,
      required: true,
      value: '',
      valid: null
    }
  },
  gateway: {
    name: 'windcave'
  }
});
const mapStateToProps = ({
  creditCard
}) => {
  return {
    creditCard
  };
};
const mapDispatchToProps = dispatch => {
  return {
    cardHolder: value => {
      dispatch(cardHolder(value));
    }
  };
};
const VisibleCardHolder = connect(mapStateToProps, mapDispatchToProps)(CardHolder);
export default VisibleCardHolder;